import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchUpdateProjectStatus } from '../services/patchUpdateProjectStatus.service';

export const updateProjectStatus = createAsyncThunk(
  'projects/updateProjectStatus',
  async (updateData) => {
    const { projectId, status } = updateData;
    const response = await patchUpdateProjectStatus(projectId, status);

    return response;
  }
);
